import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { ProductClass } from "../../../../core/json/ProductClass";
import {
  addNewProduct,
  getGroupEntryByGuid,
  getProductTypeguid,
  getUnitguid,
} from "../../../../services/MasterApiServices";
import toast from "react-hot-toast";
import axios from "axios";
import { fetchBrand } from "../../../../redux/userSetting";
import AddProduct from "../AddProduct";

function AddOtherDescription({
  productName,
  register,
  errors,
  watch,
  setValue,
  productImages,
  setProductImages,
  setThumbnailImage,
  thumbnailImage,
}) {
  const dispatch = useDispatch();
  const { branch } = useSelector((state) => state.branchlist);
  const { product, productsection } = useSelector((state) => state.productdata);
  const { brandList } = useSelector((state) => state.usersetting);

   const [thumbnailPreview, setThumbnailPreview] = useState(null);
  // const [thumbnailImage, setThumbnailImage] = useState(null);

  const [productImagePreviews, setProductImagePreviews] = useState([]);
  const [fileList, setFileList] = useState([]);

  // const transtext = watch("ShortDescription");

  useEffect(() => {
    dispatch(fetchBrand());
  }, []);

  const API_KEY = process.env.REACT_APP_TRANSLATION_API_KEY;

  const languages = [
    { code: "ar", name: "Arabic" },
    // { code: "hi", name: "Hindi" },
    // { code: "ml", name: "Malayalam" },
  ];

  // useEffect(() => {
  //   setValue("ShortDescription", ShortDescription);
  // }, [ShortDescription, setValue]);

  // useEffect(() => {
  //   if (product?.ShortDescription) {
  //     setValue("ShortDescription", product.ShortDescription);
  //   }
  // }, [product, setValue]);

  const handleTranslation = async (targetLanguage) => {
    if (!productName) {
      toast.error("Please enter a product name to translate.");
      return;
    }

    const url = `https://translation.googleapis.com/language/translate/v2?key=${API_KEY}`;

    try {
      const response = await axios.post(
        url,
        {
          q: productName,
          target: targetLanguage,
        },
        {
          // By setting `requireheader: false`, the global headers will be blocked
          requireheader: false,
        }
      );

      const translatedText = response.data.data.translations[0].translatedText;
      setValue("ShortDescription", translatedText); // Update Arabic Description
      toast.success("Translation completed!");
    } catch (error) {
      console.error(
        "Translation error:",
        error.response?.data || error.message
      );
      toast.error("Error translating text");
    }
  };

  console.log(watch("ShortDescription"), "watch");

  console.log(brandList, "braaaaaaaaaand");

  // Function to Resize Image
  // const resizeImage = (file, width, height, callback) => {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = (event) => {
  //     const img = new Image();
  //     img.src = event.target.result;
  //     img.onload = () => {
  //       const canvas = document.createElement("canvas");
  //       const ctx = canvas.getContext("2d");

  //       canvas.width = width;
  //       canvas.height = height;
  //       ctx.drawImage(img, 0, 0, width, height);

  //       canvas.toBlob((blob) => {
  //         callback(new File([blob], file.name, { type: file.type }));
  //       }, file.type);
  //     };
  //   };
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];
  // if (fileName) {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(fileName);

  //   reader.onloadend = () => {
  //     setThumbnailImage(reader.result); // Base64 string
  //   };
  // }
  //   if (file) {
  //     resizeImage(file, 150, 150, (resizedFile) => {
  //       setThumbnailImage(resizedFile);
  //       setThumbnailPreview(URL.createObjectURL(resizedFile));
  //     });
  //   }
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];
  // console.log(file,"fileeeeeeeeeeeeeeeeee");

  // const fileName = String(file.name);
  // setThumbnailImage(fileName)
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     console.log(imageUrl, "Generated Image URL");
  //     setThumbnailImage(imageUrl); // Store the image URL instead of the file
  //     setThumbnailPreview(imageUrl);
  //   }
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file); // Convert to Base64

  //     reader.onloadend = () => {
  //       console.log(reader.result, "Base64 Image URL");
  //       setThumbnailImage(reader.result); // Store Base64 string
  //       setThumbnailPreview(reader.result);
  //     };
  //   }
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];

  //   if (!file) {
  //     console.warn("No file selected");
  //     return;
  //   }

  //   console.log(file, "Selected File");

  //   const reader = new FileReader();

  //   reader.onload = () => {
  //     const arrayBuffer = reader.result; // This is an ArrayBuffer
  //     const byteArray = new Uint8Array(arrayBuffer); // Convert to byte array

  //     console.log(byteArray, "Byte Array");

  //     // Example: Store it in state or send it to backend
  //     setThumbnailImage(byteArray); // make sure your state is ready for Uint8Array
  //   };

  //   reader.onerror = () => {
  //     console.error("Error reading file as ArrayBuffer");
  //   };

  //   reader.readAsArrayBuffer(file);
  // };

  // const handleProductImagesChange = (event) => {
  //   const files = Array.from(event.target.files);

  //   if (productImages.length + files.length > 3) {
  //     toast.error("You can upload a maximum of 3 images.");
  //     return;
  //   }

  //   files.forEach((file) => {
  //     resizeImage(file, 550, 550, (resizedFile) => {
  //       setProductImages((prevImages) => [...prevImages, resizedFile]);
  //       setProductImagePreviews((prevPreviews) => [...prevPreviews, URL.createObjectURL(resizedFile)]);
  //     });
  //   });
  // };

  //   const handleProductImagesChange = (event) => {
  //     const files = Array.from(event.target.files);
  // console.log(files,"Image upload");
  // const fileArray = Array.from(files).map((file) => URL.createObjectURL(file));
  // console.log(fileArray,"FILE Image");

  //     if (productImages.length + files.length > 3) {
  //         toast.error("You can upload a maximum of 3 images.");
  //         return;
  //     }
  //   const newFiles = fileArray.map((url) => ({
  //     // guID: "",
  //     // prodGuID: "",
  //     dImage: url,
  //     // isDeleted: 0,
  //   }));
  //   console.log(newFiles,"NEWFILES");

  //   //setProductImages(newFiles);
  //  // setProductImagePreviews(fileArray);
  //   files.forEach((newFiles) => {

  //         setProductImages((newFiles) => [...newFiles, newFiles]);
  //         setProductImagePreviews((fileArray) => [...fileArray,]);

  //     });

  // };

  // const handleProductImagesChange = (event) => {
  //   const files = Array.from(event.target.files);
  //   console.log(files, "Image upload");

  //   const fileArray = files.map((file) => URL.createObjectURL(file));
  //   console.log(fileArray, "FILE Image");

  //   if (productImages.length + files.length > 3) {
  //       toast.error("You can upload a maximum of 3 images.");
  //       return;
  //   }

  //   const newFiles = fileArray.map((url) => ({
  //       dImage: url,
  //   }));

  //   console.log(newFiles, "NEWFILES");

  //   // Correctly update state
  //   setProductImages((prevImages) => [...prevImages, ...newFiles]);
  //   setProductImagePreviews((prevPreviews) => [...prevPreviews, ...fileArray]);
  // };

  // const handleThumbnailChange = (event) => {
  //   const file = event.target.files[0];
  //   if (!file) {
  //     console.warn("No file selected");
  //     setThumbnailImage(""); // ✅ Convert null to empty string
    
  //     return;
  //   }
  //   setThumbnailImage(file); // or handle as needed
  //   // else
  //   // {setThumbnailImage(file);}

  //   // Optional: store file object if needed
   
  // };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      console.warn("No file selected");
      setThumbnailImage("");
      return;
    }
  
    const reader = new FileReader();
  
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        canvas.width = 200;
        canvas.height = 200;
  
        // Draw image resized to 200x200
        ctx.drawImage(img, 0, 0, 200, 200);
  
        // Get the new image as a Blob or data URL
        canvas.toBlob((blob) => {
          const resizedFile = new File([blob], file.name, { type: file.type });
          setThumbnailImage(resizedFile);
  
          const previewURL = URL.createObjectURL(resizedFile);
          setThumbnailPreview(previewURL);
        }, file.type);
      };
      img.src = e.target.result;
    };
  
    reader.readAsDataURL(file);
  };

//   const handleProductImagesChange = (event) => {
//     const files = Array.from(event.target.files);
//     console.log(files, "Image uploaddddddddddddddd");

//     if (productImages.length + files.length > 3) {
//       toast.error("You can upload a maximum of 3 images.");
//       return;
//     }
//     else {
// setProductImages(files);}

//   };


const handleProductImagesChange = (event) => {
  const files = Array.from(event.target.files);

  if (productImages.length + files.length > 3) {
    toast.error("You can upload a maximum of 3 images.");
    return;
  }

  const resizedImagesPromises = files.map((file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = 600;
          canvas.height = 600;

          ctx.drawImage(img, 0, 0, 600, 600);

          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], file.name, { type: file.type });
              const previewURL = URL.createObjectURL(resizedFile);
              resolve({ file: resizedFile, preview: previewURL });
            }
          }, file.type);
        };
        img.src = e.target.result;
      };

      reader.readAsDataURL(file);
    });
  });

  Promise.all(resizedImagesPromises).then((resizedData) => {
    const resizedFiles = resizedData.map((item) => item.file);
    const previewUrls = resizedData.map((item) => item.preview);

    setProductImages((prev) => [...prev, ...resizedFiles]);
    setProductImagePreviews((prev) => [...prev, ...previewUrls]);
  });
};



  const removeProductImage = (index) => {
    const updatedImages = [...productImages];
    const updatedPreviews = [...productImagePreviews];
    updatedImages.splice(index, 1);
    updatedPreviews.splice(index, 1);
    setProductImages(updatedImages);
    setProductImagePreviews(updatedPreviews);
  };

  return (
    <div>
      <div>
        <div className="modal-body custom-modal-body">
          {/* <div className="branch-tabs col-12 align-items-center justify-content-between">
            {Object.keys(errors || {})
              .map((key) => errors[key]?.message)
              .find(Boolean) && (
              <span className="error text-danger text-sm">
                {Object.keys(errors || {})
                  .map((key) => errors[key]?.message)
                  .find(Boolean)}
              </span>
            )}
          </div> */}

          {/* <div className="col-md-6 col-sm-12">
              <div className="input-blocks d-flex align-items-center">
                <label htmlFor="Short Name"
                       className="me-2"
                    style={{ width: "100px" }}>Other Language</label>
                <input type="text" placeholder="" 
                // defaultValue={ShortDescription}
                value={watch("ShortDescription")}
                  {...register("ShortDescription")}
         //shortname
                  />
              </div>
            </div> */}

          {/* <div className="col-md-6 col-sm-12">
              <div className="input-blocks d-flex align-items-center">
              <label className="col-form-label">Translate to</label>
              <div className="col-12 ms-3">
              {languages.map((lang) => (
                    <button
                      key={lang.code}
                      type="button"
                      className="btn btn-primary me-2"
                      onClick={() => handleTranslation(lang.code)}
                    >
                      {lang.name}
                    </button>
                  ))}
                     </div>
              </div>
            </div> */}

          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className="input-blocks d-flex align-items-center">
                <label
                  htmlFor="Short Name"
                  className="me-2"
                  style={{ width: "100px" }}
                >
                  Detailed Description
                </label>
                {/* <input type="text" placeholder="Short Name"  {...register("ShortName", { required: "Short Name is required" })} /> */}
                <textarea
                  id="ShortDescription"
                  placeholder="Detailed Description"
                  rows={8}
                  {...register("ShortDescription", {
                //    required: "Detailed Description is required",
                  })}
                />
                {/* {errors?.ShortName && (
                  <span className="error text-danger text-sm">
                    {errors.ShortName.message}
                  </span>
                )} */}
              </div>
            </div>

            <div className="col-md-6 col-sm-12">
              <div className="input-blocks d-flex align-items-center">
                <label
                  htmlFor="Short Name"
                  className="me-2"
                  style={{ width: "100px" }}
                >
                  Brand
                </label>
                <select
                  {...register("brand")}
                  className=" form-control"
                >
                  <option value="">Select Brand</option>
                  {brandList?.map((group) => (
                    <option key={group.guid} value={group.guid}>
                      {group.name}
                    </option>
                  ))}
                </select>

                {/* {errors?.brand && (
                  <span className="error text-danger text-sm">
                    {errors.brand.message}
                  </span>
                )} */}
              </div>
              <div className="input-blocks d-flex align-items-center">
                <label
                  htmlFor="Short Name"
                  className="me-2"
                  style={{ width: "100px" }}
                >
                  Min Price
                </label>
                <input
                  type="number"
                  placeholder=""
                  className="form-control"
                  min={0}
                  defaultValue={0}
                  {...register("MinPrice")}
                />
              </div>
            </div>
          </div>

          {/* <div className="col-md-6 col-sm-12">
              <div className="input-blocks d-flex align-items-center">
                <label  htmlFor="Short Name"
                       className="me-2"
                    style={{ width: "100px" }}>Min Price</label>
                <input type="number" placeholder=""
                className="form-control"
                min={0}
                defaultValue={0}
                 {...register("MinPrice")}
                  />
             
              </div>
            </div> */}

          {/* <div className="row"> */}
          {/* <label><b>TAX Included In:</b> </label>
          <div className="d-flex align-items-center">
  <div className="d-flex align-items-center me-4">
    <input type="checkbox" {...register("IsSalesTaxIncludedInPrice")} />
    <label className="ms-2 mb-1">Sales Rate</label>
  </div>
  <div className="d-flex align-items-center">
    <input type="checkbox" {...register("general.IsPurchaseTaxIncludedInPrice")} />
    <label className="ms-2 mb-1">Purchase Rate</label>
  </div>
</div>
  */}

          {/* <div className="col-lg-3 col-sm-12">
              <input
                type="checkbox"
                className=""
                {...register("isRateVaryProduct")}
              />{" "}
              Is product price variable?
            </div> */}
          {/* <div className="col-lg-9  col-sm-12 general_decription">
              When this setting enabled, we can change the price of product
              while billing, a popup box will show in sales screen
            </div> */}
          {/* </div> */}
          {/* <div className="row"> */}
          <div className="row mt-2 border p-2">
            <label>
              <b>ReOrder: </b>{" "}
            </label>
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="input-blocks d-flex align-items-center">
                  <label
                    htmlFor="Name"
                    className="me-2"
                    style={{ width: "100px" }}
                  >
                    Min Quantity<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder=""
                    className="form-control"
                    min={0}
                    defaultValue={0}
                    {...register("MinQty", {
                      required: "Min Quantity is required",
                    })}
                  />
                  {errors?.MinQty && (
                    <span className="error text-danger text-sm">
                      {errors.MinQty.message}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-md-6 col-sm-12">
                <div className="input-blocks d-flex align-items-center">
                  <label
                    htmlFor="Short Name"
                    className="me-2"
                    style={{ width: "100px" }}
                  >
                    Max Quantity<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder=""
                    className="form-control"
                    min={0}
                    defaultValue={0}
                    {...register("MaxQty", {
                      required: "Max Quantity is required",
                    })}
                  />
                  {errors?.MaxQty && (
                    <span className="error text-danger text-sm">
                      {errors.MaxQty.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="input-blocks d-flex align-items-center">
                  <label
                    htmlFor="Short Name"
                    className="me-2"
                    style={{ width: "100px" }}
                  >
                    Reorder Level<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder=""
                    className="form-control"
                    defaultValue={0}
                    min={0}
                    {...register("ReorderLevel", {
                      required: "Reorder Level is required",
                    })}
                  />
                  {errors?.ReorderLevel && (
                    <span className="error text-danger text-sm">
                      {errors.ReorderLevel.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="col-md-6 col-sm-12">
                <div className="input-blocks d-flex align-items-center">
                  <label
                    htmlFor="Short Name"
                    className="me-2"
                    style={{ width: "100px" }}
                  >
                    Reorder Quantity<span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    placeholder=""
                    className="form-control"
                    defaultValue={0}
                    min={0}
                    {...register("ReorderQty", {
                      required: "Reorder Quantity is required",
                    })}
                  />
                  {errors?.ReorderQty && (
                    <span className="error text-danger text-sm">
                      {errors.ReorderQty.message}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <label>
              <b>Others: </b>{" "}
            </label>
            <div className="d-flex align-items-center me-4">
              <input type="checkbox" {...register("IsMenuItem")} />
              <label className="ms-2 mb-1">Quick Item</label>
            </div>
            {/* <div className="col-lg-3 col-sm-12">
              <input type="checkbox" className="" {...register("isMenuItem")} />
              Menu Item
            </div>
            <div className="col-lg-9  col-sm-12 general_decription">
              When this setting enabled, this product is considered as a Menu
              Item that shows in BOQ
            </div> */}
          </div>
          <div className="row mt-3">
            <label>
              <b>Add Images: </b>{" "}
            </label>
            {/* Thumbnail Image Upload (Mandatory) */}
            <div className="col-md-6 col-sm-12">
              <div className="input-blocks">
                <label className="me-2" style={{ width: "150px" }}>
                  Thumbnail Image (150x150 px){" "}
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleThumbnailChange}
                />
                {/* {errors?.thumbnailImage && <span className="error text-danger">{errors.thumbnailImage.message}</span>} */}
              </div>
              {thumbnailPreview && (
                      <div className="mt-2">
                        <img src={thumbnailPreview} alt="Thumbnail Preview" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px" }} />
                      </div>
                    )}
            </div>

            {/* Product Detail Images (Multiple Uploads) */}
            <div className="col-md-6 col-sm-12">
              <div className="input-blocks">
                <label className="me-2" style={{ width: "150px" }}>
                  Product Detail Images (550x550 px){" "}
                </label>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  onChange={handleProductImagesChange}
                  disabled={productImages.length >= 3}
                />
              </div>
              {productImagePreviews.length > 0 && (
                <div className="mt-2 d-flex flex-wrap">
                  {productImagePreviews.map((image, index) => (
                    <div
                      key={index}
                      className="position-relative me-2"
                      style={{ width: "100px", height: "100px" }}
                    >
                      <img
                        src={image}
                        alt="Product Detail"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "5px",
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "-5px", right: "-5px" }}
                        onClick={() => removeProductImage(index)}
                      >
                        X
                      </button>
                    </div>
                  ))}
                </div>
              )}
              {productImages.length >= 3 && (
                <span className="text-danger mt-1 d-block">
                  Maximum 3 images allowed.
                </span>
              )}
            </div>
          </div>
          <div className="col-lg-12"></div>
        </div>
      </div>
    </div>
  );
}

export default AddOtherDescription;
